<template>
    <v-container>

        <v-row>
            
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">{{title}}</h2>
                        </v-col>
                    </v-row>

                    
                    <v-row  class="search-container">

                        <v-col cols="12" sm="6" md="2">
                            <v-menu
                                v-model="showSearchStartDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="search.startDate ? $moment(search.startDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                        label="Start Date"
                                        readonly
                                        prepend-icon="event"
                                        append-icon="close"
                                        @click:append="searchStartDateChanged(null)"
                                        v-on="on"
                                    >
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-if="showSearchStartDate"
                                    :value="search.startDate"
                                    @input="searchStartDateChanged($event)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="2">
                            <v-menu
                                v-model="showSearchEndDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="search.endDate ? $moment(search.endDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                        label="End Date"
                                        readonly
                                        prepend-icon="event"
                                        append-icon="close"
                                        @click:append="searchEndDateChanged(null)"
                                        v-on="on"
                                    >
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-if="showSearchEndDate"
                                    :value="search.endDate"
                                    @input="searchEndDateChanged($event)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="9" sm="6" md="2">
                            <v-select
                                :items="types"
                                item-text="TypeName"
                                item-value="TypeValue"
                                v-model="search.type"
                                label="Type"
                            ></v-select>
                        </v-col>

                        <v-col cols="9" sm="6" md="2">
                            <v-select
                                :items="species"
                                item-text="SpeciesFullName"
                                item-value="SpeciesID"
                                v-model="search.speciesIDs"
                                label="Species"
                                clearable
                                multiple
                            ></v-select>
                        </v-col>

                        <v-col cols="9" sm="6" md="2">
                            <v-checkbox
                                label="Open Pools Only"
                                v-model="search.openOnly"
                            ></v-checkbox>
                        </v-col>

                        <v-col cols="9" sm="6" md="2">
                            <v-checkbox
                                label="Inactive Pools Only"
                                v-model="search.inactiveOnly"
                            ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6" md="3" offset-md="3">
                            <v-btn block color="primary" :loading="loadingPools" @click="loadPools">Search</v-btn>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-btn
                                v-if="!$auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="addMonthlyPool({ Active: true })"
                            >
                                New Pool
                            </v-btn>
                        </v-col>

                    </v-row>

                    <v-row >
                        <v-col cols="12">
                            <v-alert v-if="activePoolsError" outlined :value="true" color="error" icon="error">
                                {{activePoolsError}}
                            </v-alert>
                            <v-data-table
                                :headers="headers"
                                :items="pools"
                                :loading="loadingPools"
                                :footer-props="footerProps"
                                :server-items-length="totalPoolCount"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.descending"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template  v-slot:item="props">
                                    <tr :data-id="props.item.MonthlyPoolID">
                                        <td>{{props.item.Barcode}}</td>
                                        <td>{{props.item.PoolCreatedTime | formatDate}}</td>
                                        <td>{{props.item.PoolCreatedByEmail | formatUserName(props.item.PoolCreatedUserFirstName, props.item.PoolCreatedUserLastName) }}</td>
                                        <td>{{props.item.SpeciesFullName}}</td>
                                        <td>{{props.item.IsExternal ? 'External' : 'Internal'}}</td>
                                        <td>{{(props.item.TotalWeight == null ? 0 : props.item.TotalWeight) + "g"}}</td>
                                        <td>
                                            <v-icon v-if="props.item.SpeciesBatchPoolID && props.item.SpeciesBatchPoolID > 0">mdi-checkbox-marked</v-icon>
                                            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                                        </td>
                                        <td>
                                            <v-btn
                                                :color="props.item.IsClosed ? 'info' : 'accent'"
                                                @click="openPool(props.item.MonthlyPoolID)"
                                                block
                                                v-if="!props.item.Inactive"
                                            >
                                                {{props.item.IsClosed ? "View Pool" : "Continue Pool"}}
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn
                                                class="ml-2"
                                                color="success darken-3"
                                                @click="viewDailyRecord(props.item.MonthlyPoolID)"
                                                block
                                                v-if="props.item.IsClosed&&!props.item.Inactive"
                                            >
                                                View Daily Record
                                            </v-btn>
                                            <v-btn
                                                class="ml-2"
                                                color="success"
                                                @click="closePool(props.item)"
                                                block
                                                v-if="!props.item.IsClosed&&!props.item.Inactive"
                                            >
                                                Close Pool
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn
                                                color="info"
                                                v-if="props.item.IsClosed&&!props.item.Inactive"
                                                @click="printBarcode(props.item.Barcode)"
                                            >
                                                Print Barcode
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn
                                                class="ml-2"
                                                color="success"
                                                @click="inactivePool(props.item)"
                                                block
                                                v-if="!props.item.Inactive&&!props.item.TotalWeight&&permission"
                                            >
                                                Inactivate Pool
                                            </v-btn>
                                            <v-btn
                                                class="ml-2"
                                                color="success"
                                                :loading="activingPools"
                                                @click="activePool(props.item)"
                                                block
                                                v-if="props.item.Inactive&&permission"
                                            >
                                                Activate Pool
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="!loadingPools" slot="no-data">
                                    <v-alert v-if="loadPoolsError" outlined :value="true" color="error" icon="error">
                                        {{loadPoolsError}}
                                    </v-alert>
                                    <v-alert v-if="!loadPoolsError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>

        </v-row>

        <MonthlyPoolCloseDialog ref="closeDialog" @updated="loadPools"></MonthlyPoolCloseDialog>
        <MonthlyPoolInactiveDialog ref="inactiveDialog" @updated="loadPools"></MonthlyPoolInactiveDialog>
    </v-container>
</template>

<script>
import * as VenomPoolingAPI from "@/services/venomPoolingAPI";

import util from '@/helpers/util';
import moment from 'moment';
import constants from 'comunet-btg-utah-repository-shared/constants';

import MonthlyPoolCloseDialog from './MonthlyPoolCloseDialog';
import MonthlyPoolInactiveDialog from './MonthlyPoolInactiveDialog';

export default {
    components: {
        MonthlyPoolCloseDialog,
        MonthlyPoolInactiveDialog
    },
    props: [
        
    ],
    data() {
        return {
            search: {
                speciesIDs: [],
                openOnly: false,
                inactiveOnly: false,
                startDate: null,
                endDate: null,
                type: null
            },
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "PoolCreatedTime",
                descending: true,
                page: 1
            },

            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },

            types: [
                {
                    TypeName: "All",
                    TypeValue: null
                },
                {
                    TypeName: "Internal",
                    TypeValue: 1
                },
                {
                    TypeName: "External",
                    TypeValue: 2
                }
            ],

            loadingPools: false,
            loadPoolsError: null,

            activePoolsError:null,

            activingPools: false,

            showSearchStartDate: false,
            showSearchEndDate: false,

            pools: [],
            totalPoolCount: 0,
            
            headers: [
                {
                    text: "ID",
                    value: "Barcode"
                },
                {
                    text: "Pool Created Time",
                    value: "PoolCreatedTime"
                },
                {
                    text: "Created By",
                    value: "PoolCreatedByEmail"
                },
                {
                    text: "Species",
                    value: "SpeciesFullName"
                },
                {
                    text: "Type",
                    value: "IsExternal"
                },
                {
                    text: "Total Weight",
                    value: "TotalWeight"
                },
                {
                    text: "In Species Batch Pool",
                    value: "SpeciesBatchPoolID"
                },
                {
                    text: "", // continue / view pool button
                    sortable: false
                },
                {
                    text: "", // close pool / view daily record button
                    sortable: false
                },
                {
                    text: "", // print barcode
                    sortable: false
                },
                {
                    text: "", // inactive pool
                    sortable: false
                },
            ]
        };
    },
    computed: {
        title: function() {
            return this.$route.meta.title;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        loadingSearch() {
            return this.$store.state.speciesStore.loading;
        },
        loadingData() {
            return this.loadingPools || this.loadingSearch;
        },
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        },
    },
    watch: {
        pagination: {
            async handler(){
                await this.loadPools();
            },
            deep: true
        }
    },
    methods: {
        searchStartDateChanged(newValue) {
            this.search.startDate = newValue;

            this.showSearchStartDate = false;
        },
        searchEndDateChanged(newValue) {
            this.search.endDate = newValue;

            this.showSearchEndDate = false;
        },
        async loadPools() {
            try {
                this.loadingPools = true;

                const params = {
                    ...this.search,
                    ...this.pagination
                };

                if (params.startDate) {
                    params.startDate = moment(params.startDate).utc().format();
                }
                if (params.endDate) {
                    params.endDate = moment(params.endDate).utc().format();
                }

                const data = await VenomPoolingAPI.getMonthlyPools(params);

                if (data.TotalMonthlyPools && data.TotalMonthlyPools > 0 && data.MonthlyPools && data.MonthlyPools.length == 0) {
                    // there are results but we are on a page too far away to see them => reset to page 1
                    this.pagination.page = 1;
                }

                this.totalPoolCount = data.TotalMonthlyPools;
                this.pools = data.MonthlyPools;
            }
            catch (e) {
                this.loadPoolsError = e;
            }
            finally {
                this.loadingPools = false;
            }
        },
        addMonthlyPool() {
            this.$router.push({ name: 'monthlypoolmanagement'});
        },
        printBarcode(barcode) {
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: barcode }});
            window.open(routeData.href, '_blank');
        },
        openPool(poolID){
            this.$router.push({ name: 'monthlypoolmanagementbyid', params: { monthlyPoolID: poolID }});
        },
        closePool(currentPool) {
            this.$refs.closeDialog.showDialog(currentPool.MonthlyPoolID);
        },
        inactivePool(currentPool) {
            this.$refs.inactiveDialog.showDialog(currentPool.MonthlyPoolID);
        },
        async activePool(currentPool) {

            this.activingPools = true;
            try {
                var inactivePoolRequest = {
                    MonthlyPoolID: currentPool.MonthlyPoolID,
                    Inactive: false,
                };

                await VenomPoolingAPI.createUpdateMonthlyPool(inactivePoolRequest);
                
            }
            catch (e) {
                this.activePoolsError = e;
            }
            finally{
                this.activingPools = false;
                this.loadPools();
            }

        },
        viewDailyRecord(poolID) {
            const routeData = this.$router.resolve({ name: 'dailymonthbatchrecordbyid', params: { monthlyPoolID: poolID }});
            window.open(routeData.href, '_blank');
        }
    },
    created() {
        this.$store.dispatch("speciesStore/loadSpecies");

        this.loadPools();
    },
    filters: {
        formatDate: function(value) {
            if (value){
                var date = moment(value);
                if (date.isValid){
                    return date.format(constants.DATE_FORMAT);
                } else {
                    return value;
                }
            } else {
                return "";
            }
        },
        formatUserName(email, firstname, surname){
            
            if (!email){
                return "";
            }

            var desc = "";
            if (firstname && firstname != "") {
                desc = firstname;
            }

            if (surname && surname != "") {
                desc += (desc == "" ? "" : " ") + surname;
            }
            desc += (desc == "" ? "" : " (") + email + (desc == "" ? "" : ")")

            return desc;
        },
    }
};
</script>

<style scoped lang="scss">
    .search-container {
        .flex {
            padding-left: 5px;
            padding-right: 5px;
        }
    }
</style>